import { Country } from './country';
import { Language } from './language';
import { LanguageCourse } from './language-course';
import { ProgrammeInformation } from './programme-information';
import { ProgrammeType } from './programme-type';
import { SchoolMemo } from './school-memo';
import { SystemUser } from './system-user';

export class School {

    constructor(
        public name: string,
        public schoolMemo: SchoolMemo | null,
        public hasOnlineCourse: boolean,
        public countryList: Country[],
        public courseList: LanguageCourse[],
        public programmeTypes: ProgrammeType[],
        public siteUrl: string | null,
        public street: string | null,
        public postalCode: string | null,
        public city: string | null,
        public appointmentTime: string | null,
        public lviPageUrl: string | null,
        public googleSheetUrl: string | null,
        public language: Language | null,
        public programmeInformationList: ProgrammeInformation[],
        public externalName: string | null,
        public id?: number,
        public createdBy?: SystemUser,
        public onlineCourseDescription?: string,
        public internalName?: string,
        public officialName?: string,
        public code?: string
    ){}
}
